export default "__VITE_ASSET__df650e02__"